import { combineReducers } from "redux";
import authReducer from "./auth";
import matchesReducer from "./mtaches"
import userReducer from "./currUser"
const allReducer = combineReducers({
    auth :authReducer,
    match:matchesReducer,
    currentUser: userReducer
});

export default allReducer

